<template>
  <el-dialog
  title="用车申请"
  :visible.sync="show"
  :before-close="close"
  center
  destroy-on-close>
    <el-form
    ref="form"
    :rules="rules"
    :model="info"
    label-width="35%">
      <el-row>
        <el-col :span="12">
          <el-form-item label="编号" prop="eventId" v-if="type !== 'new'">
            <el-input
            disabled
            placeholder="编号"
            show-word-limit
            v-model="info.eventId"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="车牌号" prop="carNo">
            <el-select
            :disabled="type !== 'new'"
            v-model="info.carNo"
            style="width: 100%"
            filterable 
            @change="changeCar" clearable>
              <el-option
              v-for="item in carList"
              :key="item.id"
              :label="item.carNo"
              :value="item.carNo"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="品牌" prop="brand">
            <el-input  disabled v-model="info.brand"/>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="使用周期" prop="begin" label-width="16%">
             <el-date-picker
              :disabled="type !== 'new'"
              @change="timeChange"
              v-model="timeValue"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="pickerOptions">
            </el-date-picker>
            <!-- <el-input  placeholder="请输入车辆载人量" v-model="info.carManned"/> -->
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="使用里程" >
            <el-input-number v-model="info.distance" :min="0" :max="1000" placeholder="请输入使用里程" 
                                style="width:100%;margin-right:5px" :controls="false"
                                :disabled="type !== 'new'"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="驾驶员" prop="driver">
            <el-input :disabled="type !== 'new'"  placeholder="请输入驾驶员" v-model="info.driver"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="驾驶员联系方式" prop="driverTel">
            <el-input :disabled="type !== 'new'"  placeholder="请输入驾驶员联系方式" v-model="info.driverTel"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="是否出省" prop="needLeaveProvince" class="leaveProvinceItem">
            <el-select :disabled="type !== 'new'" placeholder="请选择" v-model="info.needLeaveProvince" style="width: 100%">
              <el-option :value="true" label="是"/>
              <el-option :value="false" label="否"/>
            </el-select>
            <!-- <p v-if="info.needLeaveProvince" style="color: red;">用车出省，需要提交到总部审批!!!</p> -->
            <p v-if="info.needLeaveProvince && info.needLeaveProvince === true" style="color: red;">用车出省，需要提交到经联社审批!!!</p>
            <p v-if="info.needLeaveProvince && info.needLeaveProvince === false" style="color: red;">用车出省，需要提交到总部审批!!!</p>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属部门" prop="deptName" :rules="{ required: true, message: '请选择部门', trigger: 'change' }">
            <el-select style="width: 100%" clearable id="selectInput" @clear="deptDataFilter" :disabled="type !== 'new'" v-model="info.deptName" filterable placeholder="请选择/输入" ref="searchSelect" :filter-method="(val) => deptDataFilter(val)">
              <el-option v-for="item in deptNameList" :key="item" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="申请原因(含目的地)" prop="applyReason"  label-width="16%">
            <el-input
            :disabled="type !== 'new'"
            type="textarea"
            :rows="5"
            placeholder="请输入申请原因"
            maxlength="200"
            show-word-limit
            v-model="info.applyReason"/>
          </el-form-item>
        </el-col>
        <template  v-if="auditInfo.approvalFlag">
          <el-col :span="12">
            <el-form-item
            label="审核状态"
            prop="status"
            :rules="{
              required: true, message: '请选择审核状态', trigger: 'change'
            }">
              <el-select v-model="info.status" @change="handleRemark">
                <el-option :value="item.value" :label="item.label"  v-for="(item,index) in statusOptions" :key="index"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
            label="审核原因"
            label-width="15%"
           >
              <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入审核原因"
              @input="changeMessage($event)"
              v-model="info.remark"/>
            </el-form-item>
          </el-col>
        </template>
        <template v-if="type === 'new' || info.status === 0">
          <el-col :span="12">
            <approvalRadio  v-model="isSubmitApproval" v-show="type === 'new'"/>
          </el-col>
          <el-col :span="12">
            <el-form-item label="下一级审核人" prop="auditPersonId" v-if="activeName == 'queryMine'">
              <el-select v-model="info.auditPersonId" placeholder="请选择" clearable filterable :disabled="type !== 'new'">
                <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="下一级审核人" prop="auditPersonId" v-else>
            <el-input v-model="this.info.auditPerson" disabled />
          </el-form-item>
          </el-col>
        </template>
      <template v-if="activeName == 'queryMyAudit'">
          <el-col :span="12">
            <el-form-item label="是否结束审核" prop="lastUserFlag" v-if="info.status == '1'">
              <el-radio v-model="info.lastUserFlag" :label="1">是</el-radio>
              <el-radio v-model="info.lastUserFlag" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <approvalRadio  v-model="isSubmitApproval" v-show="info.status == '1' && info.lastUserFlag == 0"/>
          </el-col>
          <el-col :span="12">
            <el-form-item label="下一级审核人" prop="nextAuditUserName" v-if="info.status == '1' && info.lastUserFlag == 0">
              <el-select v-model="info.nextAuditUserName" placeholder="请选择" clearable filterable>
                <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <approvalRadio  v-model="isSubmitApproval" v-show="info.status == '3'"/>
          </el-col>
          <el-col :span="12">
            <el-form-item label="转办人" prop="nextAuditUserName" v-if="info.status == '3'">
              <el-select v-model="info.nextAuditUserName" placeholder="请选择" clearable filterable>
                <el-option v-for="item in userInfoList" :key="item.id" :label="item.chineseName" :value="item.userName">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
      </template>
      </el-row>
    </el-form>
    <review-process
    v-show="type !== 'endUseCar'"
    :processList="auditInfo.auditProcessEntityList"
    :createTime="auditInfo.createTime"
    :createUser="auditInfo.applyUser"
    :auditPerson="auditInfo.auditPerson"
    />
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="addEventForm()" v-if="type === 'new' || auditInfo.approvalFlag">提 交</el-button>
      <el-button type="primary" @click="addStagingForm()" v-if="(type === 'new' && info.status === 10) || (type === 'new' && info.status === '') ">暂 存</el-button>
      <el-button type="primary" v-else-if="type === 'endUseCar'" @click="endUseCar">结束用车</el-button>
      <el-button @click="close">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { query, submitApply, auditAndNextUser, getApplyDetail, stopUse, stagingApply } from '@/api/carInfo.js'
import { listCompanyfInfo } from '@/api/searchList'
import ReviewProcess from '@/components/ReviewProcess.vue'
import { validPhone } from '@/assets/scripts/validate'
// import { queryUserInfo } from '@/api/basicInfo'
import approval from '@/mixins/approval'
import companyDepts from '@/utils/companyDepts'
export default {
  mixins: [approval],
  components: {
    ReviewProcess
  },
  data () {
    return {
      timeValue: [],
      result: {},
      info: {
        carNo: '',
        brand: '',
        begin: '', // 使用开始时间开始日期时间
        end: '', // 使用开始时间结束日期时间
        distance: '', // 公里数
        driver: '',
        driverTel: '',
        needLeaveProvince: '',
        eventId: '',
        applyReason: '',
        status: '',
        remark: '',
        deptName: '',

        lastUserFlag: '',
        nextAuditUserName: '',
        auditPersonId: '',
      },
      statusOptions: [
        {
          value: '1',
          label: '通过'
        },
        {
          value: '2',
          label: '拒绝'
        },
        {
          value: '3',
          label: '转办'
        },
        {
          value: '4',
          label: '退回上一级'
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      carList: [],
      rules: {
        carNo: [{ required: true, message: '请输入车牌号', trigger: 'change' }],
        brand: [{ required: true, message: '请输入车辆品牌', trigger: 'change' }],
        begin: [{ required: true, message: '请选择使用周期', trigger: 'change' }],
        distance: [{ required: true, message: '请输入公里数', trigger: 'blur' }],
        driver: [{ required: true, message: '请输入驾驶员', trigger: 'blur' }],
        driverTel: [{ required: true, message: '请填写', trigger: 'blur' }, { validator: validPhone, trigger: 'blur' }],
        needLeaveProvince: [{ required: true, message: '请选择是否出省', trigger: 'change' }],
        applyReason: [{ required: true, message: '请输入申请原因', trigger: 'blur' }],
        nextAuditUserName: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
        auditPersonId: [{ required: true, message: '请选择下一级审核人', trigger: 'change' }],
        lastUserFlag: [{ required: true, message: '请选择是否结束审核', trigger: 'change' }],
      },
      id: '',
      type: '',
      actionType: '',
      show: false,
      // userInfoList: [],
      activeName: '',
      baseDeptsNameList: ['财务部', '招商部', '综合部', '办公室', '工会', '人事部'],
      deptNameList: [],
      deptOptionsFilter: [],
      auditInfo: {
        auditProcessEntityList: [],
        createTime: '',
        applyUser: '',
        auditPerson: '',
        approvalFlag: false
      }
    }
  },
  mounted() {
    this.queryList()
    this.getCompanyList()
  },
  methods: {
    deptDataFilter(val) {
      if (val) {
        this.info.deptName = val
        this.deptNameList = this.deptOptionsFilter.filter((item) => {
          if (item.includes(val) || item.toUpperCase().includes(val.toUpperCase())) {
            return true
          } else {
            this.$nextTick(() => {
              this.$refs['info'].clearValidate('deptName')
            })
          }
        })
      } else {
        this.deptNameList = this.deptOptionsFilter
      }
    },
    handleStatus(creatUser) {
     let userName = JSON.parse(localStorage.getItem('jiadingFangwu_userInfo')).userName
     if (userName === creatUser) {
      this.statusOptions = [
        {
          value: '1',
          label: '通过'
        },
        {
          value: '2',
          label: '拒绝'
        },
        {
          value: '3',
          label: '转办'
        },
      ]
     }
    },
    handleRemark(val) {
      if (val === '1') {
        this.info.remark = '同意'
      } else if (val === '3') {
        this.info.remark = '转办'
      } else {
        this.info.remark = ''
      }
    },
    // 强制更新测试文本信息框的值
    changeMessage() {
      this.$forceUpdate()
    },
    // async queryList() {
    //         let res = await queryUserInfo({
    //             pageNum: 1,
    //             pageSize: 9999,
    //         })
    //         if (res.code === 0) {
    //             this.userInfoList = res.result.records
    //         }
    //     },
    showDetails (type, id, activeName) {
      this.type = type
      this.show = true
      this.activeName = activeName
      this.getCarList()
      if (id) {
        this.getDetails(id)
      }
    },
    getDetails (id) {
      this.id = id
      getApplyDetail({ id }).then(res => {
        const { code, result } = res
        if (code !== 0) return
        this.info = {
          carNo: result.carNo,
          brand: result.brand,
          begin: result.begin, // 使用开始时间开始日期时间
          end: result.end, // 使用开始时间结束日期时间
          distance: result.distance, // 公里数
          driver: result.driver,
          driverTel: result.driverTel,
          needLeaveProvince: result.needLeaveProvince,
          eventId: result.eventId,
          applyReason: result.applyReason,
          deptName: result.deptName,

          lastUserFlag: result.lastUserFlag,
          nextAuditUserName: result.nextAuditUserName,
          auditPersonId: result.auditPersonId,
          status: result.approvalFlag === true ? '' : result.status,
        }
        this.handleStatus(result.createUser)
        this.timeValue = [result.begin, result.end]
        this.auditInfo = {
          auditProcessEntityList: result.auditProcessEntityList,
          createTime: result.createTime,
          applyUser: result.applyUser,
          auditPerson: result.auditPerson,
          approvalFlag: result.approvalFlag
        }
        if (this.type === 'new' && this.info && this.info.auditPersonId && result.status === 10) {
          this.info.auditPersonId = ''
        }
      })
    },
    close () {
      this.show = false
      this.timeValue = []
      this.info = {
        carNo: '',
        brand: '',
        begin: '', // 使用开始时间开始日期时间
        end: '', // 使用开始时间结束日期时间
        distance: '', // 公里数
        driver: '',
        driverTel: '',
        needLeaveProvince: '',
        eventId: '',
        applyReason: '',
        status: '',
        lastUserFlag: '',
        nextAuditUserName: '',
        auditPersonId: '',
        deptName: '',
        remark: ''
      }
      this.auditInfo = {
        auditProcessEntityList: [],
        createTime: '',
        applyUser: '',
        auditPerson: '',
        approvalFlag: false
      }
      this.id = ''
    },
    addEventForm () {
      this.$refs.form.validate(async(vaild) => {
        if (vaild) {
          if (this.actionType === 'new' || this.actionType === 'update') {
            console.log(this.info.needLeaveProvince);
            if (this.info.needLeaveProvince && this.actionType === 'new') {
              this.$alert('用车出省，需要提交到总部审批', '提示', {
                confirmButtonText: '确定',
                type: 'warning',
                callback: async () => {
                  let res = await submitApply({ 
                    applyReason: this.info.applyReason,
                    begin: this.info.begin,
                    brand: this.info.brand,
                    carNo: this.info.carNo,
                    distance: this.info.distance,
                    driver: this.info.driver,
                    driverTel: this.info.driverTel,
                    end: this.info.end,
                    needLeaveProvince: this.info.needLeaveProvince,
                    auditPersonId: this.info.auditPersonId,
                    eventId: this.info.eventId,
                    deptName: this.info.deptName,
                  })
                  const { code } = res
                  if (code !== 0) {
                    // this.$message.error(message)
                    return
                  }
                  this.$message.success('提交成功！')
                  this.$emit('addSuccess')
                  this.close()
                }
              });
            } else {
              let res = await submitApply({ 
                applyReason: this.info.applyReason,
                begin: this.info.begin,
                brand: this.info.brand,
                carNo: this.info.carNo,
                distance: this.info.distance,
                driver: this.info.driver,
                driverTel: this.info.driverTel,
                end: this.info.end,
                needLeaveProvince: this.info.needLeaveProvince,
                auditPersonId: this.info.auditPersonId,
                eventId: this.info.eventId,
                deptName: this.info.deptName,
              })
              const { code } = res
                if (code !== 0) {
                  // this.$message.error(message)
                  return
                }
                this.$message.success('提交成功！')
                this.$emit('addSuccess')
                this.close()
            }
          }
          // if (this.actionType === 'update') {
          //   res = await update({ 
          //     id: this.id,
          //     applyReason: this.info.applyReason,
          //     begin: this.info.begin,
          //     brand: this.info.brand,
          //     carNo: this.info.carNo,
          //     distance: this.info.distance,
          //     driver: this.info.driver,
          //     driverTel: this.info.driverTel,
          //     end: this.info.end,
          //     needLeaveProvince: this.info.needLeaveProvince,
          //     auditPersonId: this.info.auditPersonId,
          //     status: 0
          //    })
          // }
          if (this.auditInfo.approvalFlag) {
            let res = await auditAndNextUser({
              id: this.id,
              remark: this.info.remark,
              status: this.info.status,
              lastUserFlag: this.info.lastUserFlag,
              nextAuditUserName: this.info.nextAuditUserName,
            })
            const { code } = res
            if (code !== 0) {
              // this.$message.error(message)
              return
            }
            this.$message.success('提交成功！')
            this.$emit('addSuccess')
            this.close()
          }
        }
      })
    },
    async addStagingForm() {
      this.$refs.form.validate(async(vaild) => {
      if (vaild) {
          let res = await stagingApply({ 
              applyReason: this.info.applyReason,
              begin: this.info.begin,
              brand: this.info.brand,
              carNo: this.info.carNo,
              distance: this.info.distance,
              driver: this.info.driver,
              driverTel: this.info.driverTel,
              end: this.info.end,
              needLeaveProvince: this.info.needLeaveProvince,
              auditPersonId: this.info.auditPersonId,
              deptName: this.info.deptName,
              eventId: this.info.eventId
             })
          const { code, message } = res
          if (code !== 0) {
            this.$message.error(message)
            return
          }
          this.$message.success('暂存成功！')
          this.$emit('addSuccess')
          this.close()
        }
      })
    },
    endUseCar () {
      stopUse({
        id: this.id
      }).then(res => {
        const { code } = res
        if (code !== 0) return
        this.$message.success('用车已结束')
        this.$emit('addSuccess')
        this.close()
      })
    },
    changeCar (val) {
      let car = this.carList.find((item) => item.carNo === val)
      this.info.brand = car?.brand || ''
    },
    timeChange (val) {
      this.info.begin = val?.[0] || ''
      this.info.end = val?.[1] || ''
    },
    getCarList () {
      query({
        // carStatus: "空闲",
        pageNum: 1,
        pageSize: 999
      }).then(res => {
        const { code, result } = res
          this.loading = false
          if (code !== 0) return
          this.carList = result.records
      })
    },
    async getCompanyList() {
      let res = await listCompanyfInfo({})
      if (res && res.code === 0) {
        const companyId = JSON.parse(localStorage.getItem('jiadingFangwu_current_company')).companyId
        const companyName = res.result.filter(i => i.companyId === companyId)[0].companyName
        if (companyName === '上海荣茂工贸有限公司') {
          this.baseDeptsNameList[1] = '营商服务部'
        }
        const keys = Object.keys(companyDepts)
        if (keys.includes(companyName)) {
          const newDepts = companyDepts[companyName]
          this.deptNameList = [...newDepts, ...this.baseDeptsNameList]
          this.optionsFilter = [...newDepts, ...this.baseDeptsNameList]
        } else {
          this.deptNameList = this.baseDeptsNameList
          this.optionsFilter = this.baseDeptsNameList
        }
      } else {
        this.deptNameList = this.baseDeptsNameList
        this.optionsFilter = this.baseDeptsNameList
      }
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog{
  min-width: 850px;
  width: 50%;
}
.leaveProvinceItem {
  position: relative;
  p {
    position: absolute;
    left: 0;
    top: 40px;
    // font-size: ;
  }
}
</style>
